import { BaseApi } from './base.api.js';

export class CrisisRecoveryActivityApi extends BaseApi {
    constructor(client, basePath = '/crisis-recovery-activities') {
        super(client, basePath);
    }
}
